<h4 class="fd-subtitle">Janela de ativação:</h4>
<form *ngIf="formGroup" [formGroup]="formGroup">
  <div fxLayout="column" fxLayoutAlign="center stretch">
    <div>
      <fd-option-picker [parentForm]="formGroup" [field]="fields.days"></fd-option-picker>
    </div>
    <div fxLayoutGap="20px">
      <div fxFlex="50">
        <fd-input [parentForm]="formGroup" [field]="fields.dataInicial"></fd-input>
      </div>
      <div fxFlex="50">
        <fd-input [parentForm]="formGroup" [field]="fields.dataFinal"></fd-input>
      </div>
    </div>
    <div>
      <div>
        <fd-input [parentForm]="formGroup" [field]="fields.observation"></fd-input>
      </div>
    </div>

    <fd-button fdSecondary [content]="'cancelar'" id="btnCancel" (trigger)="back()"> </fd-button>
    <fd-button [content]="'próxima etapa'" id="btnNext" (trigger)="btnNext()"> </fd-button>
  </div>
</form>
